import {useHeaderData} from '../Header/helpers';

// the data source is completely the same, so to not have outdated responses we just link the data fetcher
export const useCategorySliderData = useHeaderData;
